export default __webpack_public_path__ + "static/media/nucleo-icons.bd42d77b.eot";